function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M400.129 179.118l49.871-.552s-3.123-8.897-11.693-9.012c-8.57-.115-5.326-10.436-15.857-10.436-14.695 0-10.991 10.436-10.991 10.436s.799-2.643-9.369-2.207c-10.168.437-1.961 11.771-1.961 11.771z",
  fill: "url(#clouds_svg__clouds_svg__paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1193 152.118h92s-7.76-22.85-24.24-14.994c-5.79 2.766-.86-14.451-18.18-14.995-17.32-.543-21.93 17.662-21.93 17.662s-.41-8.398-12.4-7.855c-11.98.544-15.25 20.182-15.25 20.182z",
  fill: "url(#clouds_svg__clouds_svg__paint1_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1130 93.118h40.67s8.7-17-7.52-17-15.05 8.5-15.05 8.5-1.64-3.906-9.4-2.298c-7.76 1.608-8.7 10.798-8.7 10.798z",
  fill: "url(#clouds_svg__clouds_svg__paint2_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M529.813 81.118L623 80.343s-6.187-18.805-15.634-15.95c-5.164 1.55-4.355-14.012-14.683-13.819-8.376.17-8.709 11.085-8.709 11.085s-3.712-17.329-14.825-18.49c-11.113-1.162-9.186 17.91-9.186 17.91s-3.879-10.311-12.731-7.407c-6.115 2.01-4.997 14.207-4.997 14.207s-17.11-7.963-12.422 13.239z",
  fill: "url(#clouds_svg__clouds_svg__paint3_linear)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M725 30.118h99.998s.631-11.024-21.451-11.024c-5.362 0 4.732-17.509-14.51-18.157-19.243-.648-12.618 18.157-12.618 18.157S770.425-1.981 755.283.289c-12.87 1.912-9.779 14.914-9.779 14.914S726.893 4.503 725 30.118z",
  fill: "url(#clouds_svg__clouds_svg__paint4_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 187.118h81s-3.846-18.298-16.344-18.051c-12.499.247-10.336-13.105-24.036-11.869-13.7 1.237-20.91 14.836-20.91 14.836S1.681 165.853 0 187.118z",
  fill: "url(#clouds_svg__clouds_svg__paint5_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1506.28 158.118H1617s-1.43-28.158-26.54-24.579c-7.13 1.026-9.47-17.253-28.46-17.42-28.7-.238-27.5 22.193-27.5 22.193s-31.8-6.205-28.22 19.806z",
  fill: "url(#clouds_svg__clouds_svg__paint6_linear)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95 80.118h61s-3.167-14.718-14.007-12.661c-16.868 3.21-13.42-4.529-26.652-6.239C102.109 59.508 95 80.118 95 80.118z",
  fill: "url(#clouds_svg__clouds_svg__paint7_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1688 61.118h60s-1.88-16.763-14.59-19.637c-12.7-2.873-17.65 12.213-17.65 12.213s-8.7-10.776-19.76-7.423c-6.49 1.963-8 14.847-8 14.847z",
  fill: "url(#clouds_svg__clouds_svg__paint8_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint0_linear",
  x1: 460.93,
  y1: 186.84,
  x2: 460.93,
  y2: 156.791,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint1_linear",
  x1: 1303.97,
  y1: 163.701,
  x2: 1303.97,
  y2: 118.627,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint2_linear",
  x1: 1181.87,
  y1: 99.682,
  x2: 1181.87,
  y2: 74.14,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint3_linear",
  x1: 642.386,
  y1: 95.79,
  x2: 642.386,
  y2: 38.696,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint4_linear",
  x1: 845.623,
  y1: 41.701,
  x2: 845.623,
  y2: -3.373,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint5_linear",
  x1: 97.705,
  y1: 198.701,
  x2: 97.705,
  y2: 153.627,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint6_linear",
  x1: 1639.89,
  y1: 174.335,
  x2: 1639.89,
  y2: 111.231,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint7_linear",
  x1: 168.58,
  y1: 87.454,
  x2: 168.58,
  y2: 58.907,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "clouds_svg__clouds_svg__paint8_linear",
  x1: 1760.37,
  y1: 68.84,
  x2: 1760.37,
  y2: 38.791,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.01
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})));

var SvgClouds = function SvgClouds(props) {
  return React.createElement("svg", _extends({
    width: 1748,
    height: 188,
    viewBox: "0 0 1748 188",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTc0OCIgaGVpZ2h0PSIxODgiIHZpZXdCb3g9IjAgMCAxNzQ4IDE4OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNDAwLjEyOSAxNzkuMTE4bDQ5Ljg3MS0uNTUycy0zLjEyMy04Ljg5Ny0xMS42OTMtOS4wMTJjLTguNTctLjExNS01LjMyNi0xMC40MzYtMTUuODU3LTEwLjQzNi0xNC42OTUgMC0xMC45OTEgMTAuNDM2LTEwLjk5MSAxMC40MzZzLjc5OS0yLjY0My05LjM2OS0yLjIwN2MtMTAuMTY4LjQzNy0xLjk2MSAxMS43NzEtMS45NjEgMTEuNzcxeiIgZmlsbD0idXJsKCNjbG91ZHNfc3ZnX19wYWludDBfbGluZWFyKSIvPgogIDxwYXRoIGQ9Ik0xMTkzIDE1Mi4xMThoOTJzLTcuNzYtMjIuODUtMjQuMjQtMTQuOTk0Yy01Ljc5IDIuNzY2LS44Ni0xNC40NTEtMTguMTgtMTQuOTk1LTE3LjMyLS41NDMtMjEuOTMgMTcuNjYyLTIxLjkzIDE3LjY2MnMtLjQxLTguMzk4LTEyLjQtNy44NTVjLTExLjk4LjU0NC0xNS4yNSAyMC4xODItMTUuMjUgMjAuMTgyeiIgZmlsbD0idXJsKCNjbG91ZHNfc3ZnX19wYWludDFfbGluZWFyKSIvPgogIDxwYXRoIGQ9Ik0xMTMwIDkzLjExOGg0MC42N3M4LjctMTctNy41Mi0xNy0xNS4wNSA4LjUtMTUuMDUgOC41LTEuNjQtMy45MDYtOS40LTIuMjk4Yy03Ljc2IDEuNjA4LTguNyAxMC43OTgtOC43IDEwLjc5OHoiIGZpbGw9InVybCgjY2xvdWRzX3N2Z19fcGFpbnQyX2xpbmVhcikiLz4KICA8cGF0aCBkPSJNNTI5LjgxMyA4MS4xMThMNjIzIDgwLjM0M3MtNi4xODctMTguODA1LTE1LjYzNC0xNS45NWMtNS4xNjQgMS41NS00LjM1NS0xNC4wMTItMTQuNjgzLTEzLjgxOS04LjM3Ni4xNy04LjcwOSAxMS4wODUtOC43MDkgMTEuMDg1cy0zLjcxMi0xNy4zMjktMTQuODI1LTE4LjQ5Yy0xMS4xMTMtMS4xNjItOS4xODYgMTcuOTEtOS4xODYgMTcuOTFzLTMuODc5LTEwLjMxMS0xMi43MzEtNy40MDdjLTYuMTE1IDIuMDEtNC45OTcgMTQuMjA3LTQuOTk3IDE0LjIwN3MtMTcuMTEtNy45NjMtMTIuNDIyIDEzLjIzOXoiIGZpbGw9InVybCgjY2xvdWRzX3N2Z19fcGFpbnQzX2xpbmVhcikiLz4KICA8cGF0aCBkPSJNNzI1IDMwLjExOGg5OS45OThzLjYzMS0xMS4wMjQtMjEuNDUxLTExLjAyNGMtNS4zNjIgMCA0LjczMi0xNy41MDktMTQuNTEtMTguMTU3LTE5LjI0My0uNjQ4LTEyLjYxOCAxOC4xNTctMTIuNjE4IDE4LjE1N1M3NzAuNDI1LTEuOTgxIDc1NS4yODMuMjg5Yy0xMi44NyAxLjkxMi05Ljc3OSAxNC45MTQtOS43NzkgMTQuOTE0UzcyNi44OTMgNC41MDMgNzI1IDMwLjExOHoiIGZpbGw9InVybCgjY2xvdWRzX3N2Z19fcGFpbnQ0X2xpbmVhcikiLz4KICA8cGF0aCBkPSJNMCAxODcuMTE4aDgxcy0zLjg0Ni0xOC4yOTgtMTYuMzQ0LTE4LjA1MWMtMTIuNDk5LjI0Ny0xMC4zMzYtMTMuMTA1LTI0LjAzNi0xMS44NjktMTMuNyAxLjIzNy0yMC45MSAxNC44MzYtMjAuOTEgMTQuODM2UzEuNjgxIDE2NS44NTMgMCAxODcuMTE4eiIgZmlsbD0idXJsKCNjbG91ZHNfc3ZnX19wYWludDVfbGluZWFyKSIvPgogIDxwYXRoIGQ9Ik0xNTA2LjI4IDE1OC4xMThIMTYxN3MtMS40My0yOC4xNTgtMjYuNTQtMjQuNTc5Yy03LjEzIDEuMDI2LTkuNDctMTcuMjUzLTI4LjQ2LTE3LjQyLTI4LjctLjIzOC0yNy41IDIyLjE5My0yNy41IDIyLjE5M3MtMzEuOC02LjIwNS0yOC4yMiAxOS44MDZ6IiBmaWxsPSJ1cmwoI2Nsb3Vkc19zdmdfX3BhaW50Nl9saW5lYXIpIi8+CiAgPHBhdGggZD0iTTk1IDgwLjExOGg2MXMtMy4xNjctMTQuNzE4LTE0LjAwNy0xMi42NjFjLTE2Ljg2OCAzLjIxLTEzLjQyLTQuNTI5LTI2LjY1Mi02LjIzOUMxMDIuMTA5IDU5LjUwOCA5NSA4MC4xMTggOTUgODAuMTE4eiIgZmlsbD0idXJsKCNjbG91ZHNfc3ZnX19wYWludDdfbGluZWFyKSIvPgogIDxwYXRoIGQ9Ik0xNjg4IDYxLjExOGg2MHMtMS44OC0xNi43NjMtMTQuNTktMTkuNjM3Yy0xMi43LTIuODczLTE3LjY1IDEyLjIxMy0xNy42NSAxMi4yMTNzLTguNy0xMC43NzYtMTkuNzYtNy40MjNjLTYuNDkgMS45NjMtOCAxNC44NDctOCAxNC44NDd6IiBmaWxsPSJ1cmwoI2Nsb3Vkc19zdmdfX3BhaW50OF9saW5lYXIpIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImNsb3Vkc19zdmdfX3BhaW50MF9saW5lYXIiIHgxPSI0NjAuOTMiIHkxPSIxODYuODQiIHgyPSI0NjAuOTMiIHkyPSIxNTYuNzkxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjAxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iY2xvdWRzX3N2Z19fcGFpbnQxX2xpbmVhciIgeDE9IjEzMDMuOTciIHkxPSIxNjMuNzAxIiB4Mj0iMTMwMy45NyIgeTI9IjExOC42MjciIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIuMDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJjbG91ZHNfc3ZnX19wYWludDJfbGluZWFyIiB4MT0iMTE4MS44NyIgeTE9Ijk5LjY4MiIgeDI9IjExODEuODciIHkyPSI3NC4xNCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjZmZmIiBzdG9wLW9wYWNpdHk9Ii4wMSIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmYiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImNsb3Vkc19zdmdfX3BhaW50M19saW5lYXIiIHgxPSI2NDIuMzg2IiB5MT0iOTUuNzkiIHgyPSI2NDIuMzg2IiB5Mj0iMzguNjk2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjAxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iY2xvdWRzX3N2Z19fcGFpbnQ0X2xpbmVhciIgeDE9Ijg0NS42MjMiIHkxPSI0MS43MDEiIHgyPSI4NDUuNjIzIiB5Mj0iLTMuMzczIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjAxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iY2xvdWRzX3N2Z19fcGFpbnQ1X2xpbmVhciIgeDE9Ijk3LjcwNSIgeTE9IjE5OC43MDEiIHgyPSI5Ny43MDUiIHkyPSIxNTMuNjI3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjAxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iY2xvdWRzX3N2Z19fcGFpbnQ2X2xpbmVhciIgeDE9IjE2MzkuODkiIHkxPSIxNzQuMzM1IiB4Mj0iMTYzOS44OSIgeTI9IjExMS4yMzEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIuMDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJjbG91ZHNfc3ZnX19wYWludDdfbGluZWFyIiB4MT0iMTY4LjU4IiB5MT0iODcuNDU0IiB4Mj0iMTY4LjU4IiB5Mj0iNTguOTA3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNmZmYiIHN0b3Atb3BhY2l0eT0iLjAxIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZmZiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0iY2xvdWRzX3N2Z19fcGFpbnQ4X2xpbmVhciIgeDE9IjE3NjAuMzciIHkxPSI2OC44NCIgeDI9IjE3NjAuMzciIHkyPSIzOC43OTEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2ZmZiIgc3RvcC1vcGFjaXR5PSIuMDEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmZmIi8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgClouds as ReactComponent };